import Card from './Card'
import styled from '@emotion/styled'
import { StyledA } from 'components/elements/links/Anchor'
import React from 'react'
import { EmailIcon, PhoneIcon } from './icons'

const Contact = (): JSX.Element => (
	<Card title="Contact">
		<p>We&apos;re here to help.</p>
		<SidebarItem>
			<EmailIcon width={24} height={24} />
			<SidebarItemData>
				<h4>Email Us</h4>
				<StyledA href="mailto:help@hifiona.com">help@hifiona.com</StyledA>
			</SidebarItemData>
		</SidebarItem>
		<SidebarItem>
			<PhoneIcon width={24} height={24} />
			<SidebarItemData>
				<h4>Call Us</h4>
				<StyledA href="tel:(800)-614-7505">(800)-614-7505</StyledA>
			</SidebarItemData>
		</SidebarItem>
	</Card>
)

const SidebarItem = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	padding: 10px 0;
	margin-bottom: 12px;
`

const SidebarItemData = styled.div`
	padding: 0 20px;
`

export default Contact
